import { IconProps } from '../types/icons';

function StarIcon({ size = 16, className }: IconProps) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_4504_359301)">
        <path d="M14.6558 3.85612L13.1706 0.606415C12.8011 -0.202138 11.6989 -0.202138 11.3294 0.606415L9.84422 3.85612C9.69551 4.18153 9.39924 4.40628 9.05689 4.4534L5.63795 4.92398C4.7873 5.04106 4.44668 6.13565 5.06896 6.75245L5.64731 7.32569C6.5282 8.19881 7.76428 8.61391 8.99361 8.44944L13.0151 7.91141L9.41698 9.9157C8.36646 10.5009 7.63495 11.5276 7.42497 12.7116L7.24288 13.7384C7.08666 14.6193 7.97842 15.2958 8.73252 14.8685L11.7634 13.1509C12.0669 12.9789 12.4331 12.9789 12.7366 13.1509L15.7675 14.8685C16.5216 15.2958 17.4133 14.6193 17.2571 13.7384L16.6292 10.1979C16.5664 9.84335 16.6795 9.47968 16.93 9.23145L19.431 6.75245C20.0533 6.13565 19.7127 5.04106 18.862 4.92398L15.4431 4.4534C15.1008 4.40628 14.8045 4.18153 14.6558 3.85612Z" fill="#FFC300" />
      </g>
      <defs>
        <filter id="filter0_d_4504_359301" x="0.75" y="0" width="23" height="23" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4504_359301" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4504_359301" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default StarIcon;
